module.exports = __webpack_public_path__ + "img/elogpopbg.f6e69ff7.png";